import React, { useState, useEffect } from "react";
import { Document, Packer, Header, Paragraph, HeightRule, TextRun, convertInchesToTwip, PageNumber, SimpleField, NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import "./Points.css";
import { API_URL } from "./API";


const KneePointTest = ({ goBack, formData, generalData, ratioData, windingPolarityData, assistanceData, onSave, projectData, kneePointData }) => {
  const RESET_EVENT_NAME = 'ctReportDataCleared';

  const [selectedCoreCount, setSelectedCoreCount] = useState(1);
  const [activeCores, setActiveCores] = useState([0]);
  const [activeTab, setActiveTab] = useState(0);

  const [coreTestData, setCoreTestData] = useState({
    0: {
      kneeVoltage: "",
      halfKneeVoltage: "",
      appliedVoltage: {},
      measuredCurrent: {
        10: "", 20: "", 30: "", 40: "", 50: "", 60: "", 70: "", 80: "", 90: "", 100: "", 110: ""
      }
    }
  });



  const [checklistData, setChecklistData] = useState(() => {
    const savedChecklist = localStorage.getItem('points_checklist_data');
    if (savedChecklist) {
      return JSON.parse(savedChecklist);
    }
    return {
      'PNT-00': 'OK',
      'PNT-01': 'OK',
      'PNT-02': 'OK',
      'PNT-03': 'OK',
      'PNT-04': 'OK',
      'PNT-05': 'OK'
    };
  });

  const checklistItems = [
    { key: 'PNT-00', text: 'All CT quantity, rating, type & make are as per approved drawings.' },
    { key: 'PNT-01', text: 'No physical damage to any of the CT.' },
    { key: 'PNT-02', text: 'Inter-panel wiring from CTs to disconnector Terminal blocks in panel is as per approved drawing.' },
    { key: 'PNT-03', text: 'CT secondary star point terminals are properly earthed at disconnector terminal blocks.' },
    { key: 'PNT-04', text: 'CT wiring ferrules are as per drawing.' },
    { key: 'PNT-05', text: 'All CT connections are properly tightened.' }
  ];

  const handleChecklistChange = (key, value) => {
    setChecklistData(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110];

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [ctGeneralData, setctGeneralData] = useState(false);
  const [pdfDownloaded, setPdfDownloaded] = useState(false);
  const [formDownloaded, setFormDownloaded] = useState(false);



  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [testFormData, setTestFormData] = useState({});
  const [testGeneralData, setTestGeneralData] = useState({});
  const [testRatioData, setTestRatioData] = useState({});
  const [testAssistanceData, setTestAssistanceData] = useState({});
  const [testTransformerData, setTestTransformerData] = useState({});
  const [testTransformerUnits, setTestTransformerUnits] = useState({});


  const clearAllLocalStorageData = () => {
    const keysToRemove = [
      'ctFormData',
      'ct_report_data',
      'assistanceData',
      'kneePointTestData',
      'transformerRatioTestData',
      'createReportData',
      'navbarData',
      'transformerWindingPolarityData',
      'transformerUnits',
      'kneePointTestSubmitted',
      'kneePointTestPDF',
      'pointsInspectionReportWord',
      'points_checklist_data',
      'pdfDownloaded',
      'formSubmitted',
      'lastFormSubmission',
      'reportGenerated',
      'testCompleted',

      'userPreferences',
      'sessionData',
      'tempData',
      'backupData'
    ];

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });


    const allKeys = Object.keys(localStorage);
    allKeys.forEach(key => {
      if (key.toLowerCase().includes('ct') ||
        key.toLowerCase().includes('knee') ||
        key.toLowerCase().includes('point') ||
        key.toLowerCase().includes('test') ||
        key.toLowerCase().includes('form') ||
        key.toLowerCase().includes('report')) {
        localStorage.removeItem(key);
      }
    });

    console.log("All localStorage data cleared comprehensively");
  };


  const resetFormData = () => {
    setSelectedCoreCount(1);
    setActiveCores([0]);
    setActiveTab(0);
    setCoreTestData({
      0: {
        kneeVoltage: "",
        halfKneeVoltage: "",
        appliedVoltage: {},
        measuredCurrent: {
          10: "", 20: "", 30: "", 40: "", 50: "", 60: "", 70: "", 80: "", 90: "", 100: "", 110: ""
        }
      }
    });
    setIsFormSubmitted(false);
    setFormSubmitted(false);
    setPdfDownloaded(false);
    setErrorMessage("");
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });
    setTestFormData({});
    setTestGeneralData({});
    setTestRatioData({});
    setTestAssistanceData({});
    setTestTransformerData({});
    setTestTransformerUnits({});
    setctGeneralData(false);
    setIsLoading(false);

    console.log("All form states reset to initial values");
  };


  const shouldClearData = () => {
    const clearanceFlags = [
      localStorage.getItem('pdfDownloaded'),
      localStorage.getItem('formSubmitted'),
      localStorage.getItem('reportGenerated'),
      localStorage.getItem('testCompleted'),
      sessionStorage.getItem('shouldClearForm')
    ];

    return clearanceFlags.some(flag => flag === 'true');
  };


  const markFormAsCompleted = () => {
    const completionFlags = {
      pdfDownloaded: 'true',
      formSubmitted: 'true',
      reportGenerated: 'true',
      testCompleted: 'true',
      completionTimestamp: new Date().toISOString()
    };

    Object.entries(completionFlags).forEach(([key, value]) => {
      localStorage.setItem(key, value);
      sessionStorage.setItem(key, value);
    });


    sessionStorage.setItem('shouldClearForm', 'true');
  };


  useEffect(() => {
    console.log("Component initializing...");


    if (shouldClearData()) {
      console.log("Clearing data on component mount");
      clearAllLocalStorageData();
      resetFormData();

      sessionStorage.removeItem('shouldClearForm');
      sessionStorage.removeItem('pdfDownloaded');
      sessionStorage.removeItem('formSubmitted');
      sessionStorage.removeItem('reportGenerated');
      sessionStorage.removeItem('testCompleted');

      return;
    }


    loadDataFromStorage();
  }, []);


  const loadDataFromStorage = () => {
    try {
      console.log("Loading data from storage...");

      const localFormData = localStorage.getItem('ctFormData');
      const localGeneralData = localStorage.getItem('ct_report_data');
      const localAssistanceData = localStorage.getItem('assistanceData');
      const localKneePointData = localStorage.getItem('kneePointTestData');
      const localRatioData = localStorage.getItem('transformerRatioTestData');
      const localProjectData = localStorage.getItem('createReportData');
      const localNavbarData = localStorage.getItem('navbarData');
      const localTransformerData = localStorage.getItem('transformerWindingPolarityData');
      const localTransformerUnits = localStorage.getItem('transformerUnits');

      if (localFormData) setTestFormData(JSON.parse(localFormData));
      if (localGeneralData) setTestGeneralData(JSON.parse(localGeneralData));
      if (localAssistanceData) setTestAssistanceData(JSON.parse(localAssistanceData));
      if (localRatioData) setTestRatioData(JSON.parse(localRatioData));
      if (localTransformerData) setTestTransformerData(JSON.parse(localTransformerData));
      if (localTransformerUnits) setTestTransformerUnits(JSON.parse(localTransformerUnits));

      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }

      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }

      if (localKneePointData) {
        const kneeData = JSON.parse(localKneePointData);

        if (kneeData.multiCoreData) {
          setCoreTestData(kneeData.multiCoreData);
          setSelectedCoreCount(Object.keys(kneeData.multiCoreData).length);
          setActiveCores(Object.keys(kneeData.multiCoreData).map(Number));
          setActiveTab(0);
        } else if (kneeData.coreData) {
          setCoreTestData(kneeData.coreData);
          setSelectedCoreCount(Object.keys(kneeData.coreData).length);
          setActiveCores(Object.keys(kneeData.coreData).map(Number));
          setActiveTab(0);
        } else {
          const newCoreData = {
            0: {
              kneeVoltage: kneeData.kneeVoltage || "",
              halfKneeVoltage: kneeData.halfKneeVoltage || "",
              appliedVoltage: kneeData.appliedVoltage || {},
              measuredCurrent: kneeData.measuredCurrent || {
                10: "", 20: "", 30: "", 40: "", 50: "", 60: "", 70: "", 80: "", 90: "", 100: "", 110: ""
              }
            }
          };
          setCoreTestData(newCoreData);
          setSelectedCoreCount(1);
          setActiveCores([0]);
        }

        if (localStorage.getItem('kneePointTestSubmitted') === 'true') {
          setIsFormSubmitted(true);
        }
      }

      console.log("Data loaded successfully from storage");
    } catch (error) {
      console.error("Error loading data from localStorage:", error);
      setErrorMessage("Failed to load saved data");
    }
  };


  useEffect(() => {
    if (projectData && !shouldClearData()) {
      setProjectDetails(prev => ({
        ...prev,
        subProjectName: projectData.sub_project_name || "",
        categoryName: projectData.category_name || "",
        subcategoryName: projectData.subcategory_name || "",
        equipmentName: projectData.equipment_name || "",
        projectId: projectData.project_id || "",
        location: projectData.location || prev.location || ""
      }));
    }
  }, [projectData]);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (pdfDownloaded || formSubmitted) {
        markFormAsCompleted();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && (pdfDownloaded || formSubmitted)) {
        markFormAsCompleted();
      }
    };

    const handlePageShow = (event) => {

      if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        if (shouldClearData()) {
          clearAllLocalStorageData();
          resetFormData();
        }
      }
    };

    const handleFocus = () => {

      if (shouldClearData()) {
        clearAllLocalStorageData();
        resetFormData();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [pdfDownloaded, formSubmitted]);



  useEffect(() => {
    if (!shouldClearData()) {
      localStorage.setItem('points_checklist_data', JSON.stringify(checklistData));
    }
  }, [checklistData]);


  useEffect(() => {
    if (!shouldClearData()) {
      const saveTimer = setTimeout(() => {
        const dataToSave = {
          multiCoreData: coreTestData,
          selectedCoreCount,
          activeCores,
          activeTab,
          timestamp: new Date().toISOString()
        };

        localStorage.setItem('kneePointTestData', JSON.stringify(dataToSave));
      }, 1000);

      return () => clearTimeout(saveTimer);
    }
  }, [coreTestData, selectedCoreCount, activeCores, activeTab]);

  const handleCoreCountChange = (e) => {
    const count = parseInt(e.target.value);
    setSelectedCoreCount(count);

    const newActiveCores = Array.from({ length: count }, (_, i) => i);
    setActiveCores(newActiveCores);
    setActiveTab(0);

    const updatedCoreTestData = { ...coreTestData };
    newActiveCores.forEach(coreIndex => {
      if (!updatedCoreTestData[coreIndex]) {
        updatedCoreTestData[coreIndex] = {
          kneeVoltage: "",
          halfKneeVoltage: "",
          appliedVoltage: {},
          measuredCurrent: {
            10: "", 20: "", 30: "", 40: "", 50: "", 60: "", 70: "", 80: "", 90: "", 100: "", 110: ""
          }
        };
      }
    });

    setCoreTestData(updatedCoreTestData);
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const recalculateAppliedVoltages = (kneeVoltageValue) => {
    if (kneeVoltageValue && !isNaN(kneeVoltageValue)) {
      const kneeVoltageNum = parseFloat(kneeVoltageValue);
      const halfKneeVoltageValue = (kneeVoltageNum / 2).toFixed(2);

      const calculatedVoltages = {};
      percentages.forEach(percentage => {
        let calculatedVoltage;
        if (percentage === 10) {
          calculatedVoltage = ((kneeVoltageNum / 2) * 0.1).toFixed(2);
        } else if (percentage === 20) {
          calculatedVoltage = ((kneeVoltageNum / 2) * 0.2).toFixed(2);
        } else {
          const factor = 0.2 + ((percentage - 20) / 10) * 0.1;
          calculatedVoltage = ((kneeVoltageNum / 2) * factor).toFixed(2);
        }
        calculatedVoltages[percentage] = calculatedVoltage;
      });

      return {
        halfKneeVoltage: halfKneeVoltageValue,
        appliedVoltage: calculatedVoltages
      };
    }

    return {
      halfKneeVoltage: "",
      appliedVoltage: {}
    };
  };

  const isFormValid = () => {
    for (const coreIndex of activeCores) {
      const coreData = coreTestData[coreIndex] || {};

      if (!coreData.kneeVoltage || coreData.kneeVoltage.trim() === "" || isNaN(parseFloat(coreData.kneeVoltage))) {
        return false;
      }
    }

    return true;
  };


  const loadAllFormDataFromStorage = () => {
    try {
      const storedData = {
        general: {},
        pointsData: {},
        pointsDetails: {},
        testResults: {},
        measurements: {},
        observations: {},
        recommendations: {}
      };


      const generalData = localStorage.getItem('ct_report_data');
      if (generalData) {
        storedData.general = JSON.parse(generalData);
      }


      const formData = localStorage.getItem('ctFormData');
      if (formData) {
        const parsedFormData = JSON.parse(formData);
        storedData.pointsData = parsedFormData.pointsData || {};
        storedData.pointsDetails = parsedFormData.pointsDetails || {};
        storedData.testResults = parsedFormData.testResults || {};
        storedData.measurements = parsedFormData.measurements || {};
        storedData.observations = parsedFormData.observations || {};
        storedData.recommendations = parsedFormData.recommendations || {};
      }


      const kneePointData = localStorage.getItem('kneePointTestData');
      if (kneePointData) {
        const parsedKneeData = JSON.parse(kneePointData);
        storedData.pointsData = { ...storedData.pointsData, ...parsedKneeData };
      }


      const assistanceData = localStorage.getItem('assistanceData');
      if (assistanceData) {
        storedData.testResults = { ...storedData.testResults, assistance: JSON.parse(assistanceData) };
      }


      const ratioData = localStorage.getItem('transformerRatioTestData');
      if (ratioData) {
        storedData.measurements = { ...storedData.measurements, ratio: JSON.parse(ratioData) };
      }

      console.log("Loaded all form data from storage:", storedData);
      return storedData;
    } catch (error) {
      console.error("Error loading form data from storage:", error);
      return {
        general: {},
        pointsData: {},
        pointsDetails: {},
        testResults: {},
        measurements: {},
        observations: {},
        recommendations: {}
      };
    }
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };



  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setFormSubmitted(true);
    setIsLoading(true);
    setErrorMessage("");

    try {
      // Helper function to safely load data from localStorage
      const loadFormDataSafely = (key, defaultValue = {}) => {
        try {
          const data = localStorage.getItem(key);
          return data ? JSON.parse(data) : defaultValue;
        } catch (error) {
          console.error(`Error loading ${key} from localStorage:`, error);
          return defaultValue;
        }
      };

      // Helper function to ensure data is in dictionary format
      const ensureDictFormat = (data, keyPrefix = 'item') => {
        if (Array.isArray(data)) {
          const dict = {};
          data.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              Object.keys(item).forEach(key => {
                dict[`${keyPrefix}_${index}_${key}`] = item[key];
              });
            } else {
              dict[`${keyPrefix}_${index}`] = item;
            }
          });
          return dict;
        } else if (typeof data === 'object' && data !== null) {
          return data;
        } else {
          return { value: data };
        }
      };

      // Load all form data from storage
      const loadAllFormDataFromStorage = () => {
        try {
          const ctFormData = loadFormDataSafely('ctFormData', {});
          const ctGeneralData = loadFormDataSafely('ctGeneralData', {});
          const transformerWindingData = loadFormDataSafely('transformerWindingPolarityData', {});
          const transformerRatioData = loadFormDataSafely('transformerRatioTestData', {});
          const kneePointTestData = loadFormDataSafely('kneePointTestData', {});
          const navbarData = loadFormDataSafely('navbarData', {});
          const createReportData = loadFormDataSafely('createReportData', {});
          const checklistData = loadFormDataSafely('points_checklist_data', {});

          // Merge general data from various sources
          const mergedGeneralData = {
          ...ctGeneralData,
          ...ctFormData,
          ...generalData,
          // Ensure all required fields are present
          formData: ctGeneralData.formData || {},
          rows: ctGeneralData.rows || [],
          generalInspection: ctGeneralData.generalInspection || {
            visualInspection: "",
            wiringChecking: "",
            erectionChecking: ""
          },
          units: ctGeneralData.units || [],
          selectedCore: ctGeneralData.selectedCore || ctFormData.selectedCore
        };

          // Merge knee point data
          const mergedKneePointData = {
            ...kneePointTestData,
            multiCoreData: coreTestData,
            selectedCoreCount,
            activeCores,
            activeTab
          };

           return {
          general: mergedGeneralData,
          // **FIX: Add this duplicate key for backward compatibility**
          ct_general_data: mergedGeneralData,
          generalData: mergedGeneralData,
          kneePointData: mergedKneePointData,
          ratioData: transformerRatioData,
          windingPolarityData: transformerWindingData,
          observations: loadFormDataSafely('observations', {}),
          recommendations: loadFormDataSafely('recommendations', {}),
          navbarData: navbarData,
          createReportData: createReportData,
          checklistData: checklistData,
          points_checklist_data: checklistData
        };
        } catch (error) {
        console.error("Error loading form data from storage:", error);
        return {
          general: {},
          ct_general_data: {},
          generalData: {},
          kneePointData: {},
          ratioData: {},
          windingPolarityData: {},
          observations: {},
          recommendations: {},
          navbarData: {},
          createReportData: {},
          checklistData: checklistData
        };
      }
      };

     const allFormData = loadAllFormDataFromStorage();

    const safeFormData = {
      general: allFormData.general,
      ct_general_data: allFormData.ct_general_data,
      generalData: allFormData.generalData,
      kneePointData: allFormData.kneePointData,
      ratioData: allFormData.ratioData,
      windingPolarityData: allFormData.windingPolarityData,
      observations: allFormData.observations,
      recommendations: allFormData.recommendations,
      navbarData: allFormData.navbarData,
      createReportData: allFormData.createReportData,
      checklistData: allFormData.checklistData,
      points_checklist_data: allFormData.points_checklist_data
    };
      // Generate Word document blob
      const wordBlob = await generateWordBlob(safeFormData);

      const reader = new FileReader();
      reader.readAsDataURL(wordBlob);

      reader.onloadend = async () => {
        try {
          const base64data = reader.result;

          // Save to localStorage
          localStorage.setItem('pointsInspectionReportWord', base64data);
          const currentDate = new Date().toISOString().split('T')[0];

          // Extract location from various sources
          const extractLocation = () => {
            const locationSources = [
              safeFormData?.general?.location,
              projectDetails?.location,
              safeFormData?.general?.testLocation,
              safeFormData?.general?.site,
              safeFormData?.general?.place,
              safeFormData?.navbarData?.location,
              safeFormData?.createReportData?.location,
              generalData?.location
            ];

            for (let loc of locationSources) {
              if (loc) {
                if (typeof loc === 'object' && loc !== null) {
                  loc = loc.value || loc.name || loc.location || loc.text || String(loc);
                }

                const finalLoc = String(loc).trim();
                if (finalLoc && finalLoc !== "" && finalLoc !== "undefined" && finalLoc !== "null") {
                  return finalLoc;
                }
              }
            }

            try {
              const localGeneralData = localStorage.getItem('ct_report_data');
              if (localGeneralData) {
                const parsedData = JSON.parse(localGeneralData);
                if (parsedData.location) {
                  const finalLoc = String(parsedData.location).trim();
                  if (finalLoc && finalLoc !== "" && finalLoc !== "undefined" && finalLoc !== "null") {
                    return finalLoc;
                  }
                }
              }
            } catch (error) {
              console.error("Error parsing localStorage data:", error);
            }

            return "Default Location";
          };

          const location = extractLocation();

          // Get project ID with validation
          const getProjectId = () => {
            if (projectData?.project_id) {
              const id = parseInt(projectData.project_id);
              if (!isNaN(id) && id > 0) {
                return id;
              }
            }

            if (projectDetails?.projectId) {
              const id = parseInt(projectDetails.projectId);
              if (!isNaN(id) && id > 0) {
                return id;
              }
            }

            try {
              const createReportData = localStorage.getItem('createReportData');
              if (createReportData) {
                const parsedData = JSON.parse(createReportData);
                if (parsedData.project_id) {
                  const id = parseInt(parsedData.project_id);
                  if (!isNaN(id) && id > 0) {
                    return id;
                  }
                }
              }
            } catch (error) {
              console.error("Error parsing createReportData:", error);
            }

            if (safeFormData?.general?.project_id) {
              const id = parseInt(safeFormData.general.project_id);
              if (!isNaN(id) && id > 0) {
                return id;
              }
            }

            throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
          };

          const projectId = getProjectId();

          // Prepare API request data
          const apiRequestData = {
            equipment_name: String(
              projectDetails?.equipmentName ||
              safeFormData?.general?.equipment ||
              "Current Transformer"
            ),
            test_date: String(
              safeFormData?.general?.date ||
              currentDate
            ),
            category_name: String(
              projectDetails?.categoryName ||
              "Current Transformer"
            ),
            subcategory_name: String(
              projectDetails?.subcategoryName ||
              "Knee Point Test"
            ),
            sub_project_name: String(
              projectDetails?.subProjectName ||
              safeFormData?.general?.project ||
              "CT Project"
            ),
            project_id: projectId,
            location: location,
            report_file: {
              report_word: base64data,
              filename: `CT_KneePoint_Test_Report_${Date.now()}.docx`,
              file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },
            test_data: safeFormData
          };

          // Make API call
          const response = await fetch(`${API_URL}/test_report/create_test_report`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(apiRequestData),
            mode: 'cors',
            credentials: 'same-origin',
          });

          if (!response.ok) {
            let errorData;
            try {
              errorData = await response.json();
              console.error("Detailed API Error:", errorData);
            } catch (jsonError) {
              console.error("Could not parse error response as JSON:", jsonError);
              errorData = { message: response.statusText };
            }

            throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
          }

          const result = await response.json();
          console.log('API Response:', result);

          // Update report ID if returned
          if (result.report_id || result.id) {
            const reportId = result.report_id || result.id;

            const updatedGeneralData = {
              ...safeFormData.general,
              reportNo: reportId
            };

            const ctFormData = JSON.parse(localStorage.getItem('ctFormData') || '{}');
            ctFormData.reportNo = reportId;
            localStorage.setItem('ctFormData', JSON.stringify(ctFormData));

            setTestFormData(prev => ({ ...prev, reportNo: reportId }));

            console.log('Report ID updated:', reportId);
          }

          // Mark form as submitted
          localStorage.setItem('kneePointTestSubmitted', 'true');
          setIsFormSubmitted(true);

          alert("Data submitted successfully");

        } catch (error) {
          console.error("Error in Word document processing or API call:", error);
          setErrorMessage(`Error: ${error.message}`);
          alert(`Error saving data: ${error.message}`);
        } finally {
          setIsLoading(false);
        }
      };

      reader.onerror = () => {
        setIsLoading(false);
        setErrorMessage("Error reading Word file");
        alert("Error processing Word file");
      };

    } catch (error) {
      console.error("Error saving data:", error);

      if (error.message.includes("Failed to fetch")) {
        setErrorMessage("Cannot connect to server. Please check if the backend is running.");
        alert("Cannot connect to server. Please check if the backend is running.");
      } else if (error.message.includes("generateWordBlob is not defined")) {
        setErrorMessage("Word document generation function is missing. Please check your imports.");
        alert("Word document generation function is missing. Please check your imports.");
      } else if (error.message.includes("Unable to determine project ID")) {
        setErrorMessage(error.message);
        alert(error.message);
      } else {
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      }
      setIsLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   setErrorMessage("");
  //   setFormSubmitted(true);

  //   try {
  //     const allFormData = loadAllFormDataFromStorage();

  //     const safeFormData = formData && typeof formData === 'object' ? {
  //       general: formData.general || allFormData.general,
  //       pointsData: formData.pointsData || allFormData.pointsData,
  //       pointsDetails: formData.pointsDetails || allFormData.pointsDetails,
  //       testResults: formData.testResults || allFormData.testResults,
  //       measurements: formData.measurements || allFormData.measurements,
  //       observations: formData.observations || allFormData.observations,
  //       recommendations: formData.recommendations || allFormData.recommendations
  //     } : allFormData;

  //     const wordBlob = await generateWordBlob(safeFormData);

  //     const reader = new FileReader();
  //     reader.readAsDataURL(wordBlob);

  //     reader.onloadend = async () => {
  //       try {
  //         const base64data = reader.result;

  //         localStorage.setItem('pointsInspectionReportWord', base64data);

  //         const currentDate = new Date().toISOString().split('T')[0];

  //         const extractLocation = () => {
  //           const locationSources = [
  //             safeFormData?.general?.location,
  //             projectDetails?.location,
  //             safeFormData?.general?.testLocation,
  //             safeFormData?.general?.site,
  //             safeFormData?.general?.place,
  //             formData?.general?.location,
  //             allFormData?.general?.location,
  //             testGeneralData?.location,
  //             generalData?.location
  //           ];

  //           for (let loc of locationSources) {
  //             if (loc) {
  //               if (typeof loc === 'object' && loc !== null) {
  //                 loc = loc.value || loc.name || loc.location || loc.text || String(loc);
  //               }

  //               const finalLoc = String(loc).trim();
  //               if (finalLoc && finalLoc !== "" && finalLoc !== "undefined" && finalLoc !== "null") {
  //                 return finalLoc;
  //               }
  //             }
  //           }

  //           try {
  //             const localGeneralData = localStorage.getItem('ct_report_data');
  //             if (localGeneralData) {
  //               const parsedData = JSON.parse(localGeneralData);
  //               if (parsedData.location) {
  //                 const finalLoc = String(parsedData.location).trim();
  //                 if (finalLoc && finalLoc !== "" && finalLoc !== "undefined" && finalLoc !== "null") {
  //                   return finalLoc;
  //                 }
  //               }
  //             }
  //           } catch (error) {
  //             console.error("Error parsing localStorage data:", error);
  //           }

  //           return "Default Location";
  //         };

  //         const location = extractLocation();

  //         const getProjectId = () => {
  //           if (projectData?.project_id) {
  //             const id = parseInt(projectData.project_id);
  //             if (!isNaN(id) && id > 0) {
  //               return id;
  //             }
  //           }

  //           if (projectDetails?.projectId) {
  //             const id = parseInt(projectDetails.projectId);
  //             if (!isNaN(id) && id > 0) {
  //               return id;
  //             }
  //           }

  //           try {
  //             const createReportData = localStorage.getItem('createReportData');
  //             if (createReportData) {
  //               const parsedData = JSON.parse(createReportData);
  //               if (parsedData.project_id) {
  //                 const id = parseInt(parsedData.project_id);
  //                 if (!isNaN(id) && id > 0) {
  //                   return id;
  //                 }
  //               }
  //             }
  //           } catch (error) {
  //             console.error("Error parsing createReportData:", error);
  //           }

  //           if (safeFormData?.general?.project_id) {
  //             const id = parseInt(safeFormData.general.project_id);
  //             if (!isNaN(id) && id > 0) {
  //               return id;
  //             }
  //           }

  //           throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
  //         };

  //         const projectId = getProjectId();

  //         const apiRequestData = {
  //           equipment_name: String(projectDetails?.equipmentName || safeFormData?.general?.equipment || "Points Equipment"),
  //           test_date: String(safeFormData?.general?.date || currentDate),
  //           category_name: String(projectDetails?.categoryName || "Category"),
  //           subcategory_name: String(projectDetails?.subcategoryName || "Subcategory"),
  //           sub_project_name: String(projectDetails?.subProjectName || safeFormData?.general?.project || "Project"),
  //           project_id: projectId,
  //           location: location,
  //           report_file: {
  //             report_word: base64data,
  //             filename: `Points_Test_Report_${Date.now()}.docx`,
  //             file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  //           },
  //           test_data: {
  //             general: safeFormData?.general || {},
  //             pointsData: safeFormData?.pointsData || {},
  //             pointsDetails: safeFormData?.pointsDetails || {},
  //             testResults: safeFormData?.testResults || {},
  //             measurements: safeFormData?.measurements || {},
  //             observations: safeFormData?.observations || {},
  //             recommendations: safeFormData?.recommendations || {},
  //             report_file: {
  //               report_word: base64data,
  //               filename: `Points_Test_Report_${Date.now()}.docx`,
  //               file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  //             }
  //           }
  //         };

  //         const response = await fetch(`${API_URL}/test_report/create_test_report`, {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify(apiRequestData),
  //           mode: 'cors',
  //           credentials: 'same-origin',
  //         });

  //         if (!response.ok) {
  //           let errorData;
  //           try {
  //             errorData = await response.json();
  //             console.error("Detailed API Error:", errorData);
  //           } catch (jsonError) {
  //             console.error("Could not parse error response as JSON:", jsonError);
  //             errorData = { message: response.statusText };
  //           }

  //           throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
  //         }

  //         const result = await response.json();
  //         console.log('API Response:', result);


  //         if (result.report_id || result.id) {
  //           const reportId = result.report_id || result.id;


  //           const updatedGeneralData = {
  //             ...safeFormData.general,
  //             reportNo: reportId
  //           };


  //           const ctFormData = JSON.parse(localStorage.getItem('ctFormData') || '{}');
  //           ctFormData.reportNo = reportId;
  //           localStorage.setItem('ctFormData', JSON.stringify(ctFormData));


  //           setTestFormData(prev => ({ ...prev, reportNo: reportId }));

  //           console.log('Report ID updated:', reportId);
  //         }

  //         localStorage.setItem('kneePointTestSubmitted', 'true');
  //         setIsFormSubmitted(true);

  //         alert("Data submitted successfully");

  //       } catch (error) {
  //         console.error("Error in Word document processing or API call:", error);
  //         setErrorMessage(`Error: ${error.message}`);
  //         alert(`Error saving data: ${error.message}`);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };

  //     reader.onerror = () => {
  //       setIsLoading(false);
  //       setErrorMessage("Error reading Word file");
  //       alert("Error processing Word file");
  //     };

  //   } catch (error) {
  //     console.error("Error saving data:", error);

  //     if (error.message.includes("Failed to fetch")) {
  //       setErrorMessage("Cannot connect to server. Please check if the backend is running.");
  //       alert("Cannot connect to server. Please check if the backend is running.");
  //     } else if (error.message.includes("generateWordBlob is not defined")) {
  //       setErrorMessage("Word document generation function is missing. Please check your imports.");
  //       alert("Word document generation function is missing. Please check your imports.");
  //     } else if (error.message.includes("Unable to determine project ID")) {
  //       setErrorMessage(error.message);
  //       alert(error.message);
  //     } else {
  //       setErrorMessage(`Error: ${error.message}`);
  //       alert(`Error saving data: ${error.message}`);
  //     }
  //     setIsLoading(false);
  //   }
  // };

  // const handleDownloadPDF = async () => {
  //   setIsLoading(true);
  //   setErrorMessage("");

  //   try {

  //     const allFormData = loadAllFormDataFromStorage();


  //     const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;

  //     const wordBlob = await generateWordBlob(safeFormData);

  //     saveAs(wordBlob, 'CurrentTransformer_Test_Report.docx');


  //     setPdfDownloaded(true);
  //     localStorage.setItem('pdfDownloaded', 'true');


  //     // window.dispatchEvent(new CustomEvent(RESET_EVENT_NAME));
  //     clearAllLocalStorageData();
  //     resetFormData();

  //     alert("Word document downloaded successfully");


  //   } catch (error) {
  //     console.error("Error generating Word document:", error);
  //     setErrorMessage(`Error generating Word document: ${error.message}`);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };







  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const allFormData = loadAllFormDataFromStorage();
      const safeFormData = allFormData && typeof allFormData === 'object' ? allFormData : {
        general: generalData || {},
        pointsData: {},
        pointsDetails: {},
        testResults: assistanceData || {},
        measurements: ratioData || {},
        observations: {},
        recommendations: {}
      };

      const wordBlob = await generateWordBlob(safeFormData);

      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
      const filename = `CurrentTransformer_KneePoint_Report_${testFormData.reportNo || formattedDate}.docx`;

      saveAs(wordBlob, filename);

      // Set the form as downloaded
      setFormDownloaded(true);
      localStorage.setItem('assistanceFormDownloaded', 'true');

      // Clear all storage data
      clearAllLocalStorageData();

      // Reset all form states
      resetFormData();

      // Dispatch clear events for other components
      if (typeof window !== 'undefined') {
        // window.dispatchEvent(new CustomEvent(RESET_EVENT_NAME));
        window.dispatchEvent(new CustomEvent('ctReportDataClearedNoRedirect'));
      }

      alert("Word document downloaded successfully");

    } catch (error) {
      console.error("Error generating Word document:", error);
      setErrorMessage(`Error generating Word document: ${error.message}`);
      alert(`Error downloading document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };







  const generateWordBlob = () => {
    return new Promise((resolve, reject) => {
      try {
        const ctFormData = JSON.parse(localStorage.getItem('ctFormData') || '{}');
        const ctGeneralData = JSON.parse(localStorage.getItem('ctGeneralData') || '{}');
        const transformerWindingData = JSON.parse(localStorage.getItem('transformerWindingPolarityData') || '{}');
        const ratioTestData = JSON.parse(localStorage.getItem('transformerRatioTestData') || '{}');
        const coreRatios = JSON.parse(localStorage.getItem('transformerCoreRatios') || '{}');
        const selectedRatioCores = localStorage.getItem('selectedRatioCores') || '1';

        const tableBorders = {
          top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
          right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
        };

        const formatFieldLabel = (key) => {
          const specialCases = {
            'yom': 'Year of Manufacture',
            'il': 'Insulation Level',
            'stc': 'Short Time Current',
            'selectedFrequency': 'Frequency',
            'selectedCore': 'Number of Cores',
            'selectedSecTerm': 'Secondary Terminal',
            'reportNo': 'Report No',
            'vkValue': 'VK Value',
            'rct': 'RCT',
            'imageAtVkHalf': 'Image@VK/2'
          };

          if (specialCases[key]) {
            return specialCases[key];
          }

          return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim();
        };

        const getRemainingFormFields = (formData) => {
          const fields = [];
          const excludeFields = ['description', 'project', 'customer', 'client', 'date', 'reportNo', 'coreDetails', 'location'];

          const fieldOrder = [
            'yom', 'make', 'serialNumber', 'il', 'stc', 'insulationClass',
            'numberOfCores', 'secondaryTerminal', 'selectedFrequency', 'selectedCore',
            'selectedSecTerm'
          ];

          const generateSecondaryTerminals = (count) => {
            const terminals = [];
            for (let i = 1; i <= count; i++) {
              terminals.push(`${i}S1-${i}S2`);
            }
            return terminals.join(", ");
          };

          const processField = (key, value) => {
            if (key === 'selectedSecTerm' || key === 'secondaryTerminal') {
              const numCores = parseInt(formData.selectedCore || formData.numberOfCores || localStorage.getItem('selectedRatioCores') || 1);
              return generateSecondaryTerminals(numCores);
            }
            return String(value);
          };

          fieldOrder.forEach(key => {
            if (formData.hasOwnProperty(key) &&
              formData[key] !== null &&
              formData[key] !== undefined &&
              !excludeFields.includes(key)) {
              fields.push({
                label: formatFieldLabel(key),
                value: processField(key, formData[key])
              });
            }
          });

          Object.keys(formData).forEach(key => {
            if (!fieldOrder.includes(key) &&
              !excludeFields.includes(key) &&
              formData[key] !== null &&
              formData[key] !== undefined) {
              fields.push({
                label: formatFieldLabel(key),
                value: processField(key, formData[key])
              });
            }
          });

          return fields;
        };

        function safeToString(value) {
          if (value === null || value === undefined || value === '' || value === 'N/A') {
            return "";
          }
          return value.toString();
        }

        const numCores = parseInt(ctFormData.selectedCore || ctFormData.numberOfCores || selectedRatioCores || 1);
        const coreDetails = ctFormData.coreDetails || [];
        const remainingFields = getRemainingFormFields(ctFormData);

        const fetchImageAsBase64 = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                const base64 = dataURL.split(',')[1];
                resolve(base64);
              } catch (error) {
                console.warn("Could not convert image to base64:", error);
                resolve(null);
              }
            };
            img.onerror = function () {
              console.warn("Could not load image from URL:", url);
              resolve(null);
            };
            img.src = url;
          });
        };

        const createLightWatermark = (base64Data) => {
          return new Promise((resolve) => {
            if (!base64Data) {
              resolve(null);
              return;
            }

            try {
              const img = new Image();
              img.onload = function () {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.globalAlpha = 0.15;
                ctx.drawImage(img, 0, 0);

                const lightDataURL = canvas.toDataURL('image/png');
                const lightBase64 = lightDataURL.split(',')[1];
                resolve(lightBase64);
              };
              img.onerror = function () {
                resolve(null);
              };
              img.src = 'data:image/png;base64,' + base64Data;
            } catch (error) {
              console.warn("Could not create light watermark:", error);
              resolve(null);
            }
          });
        };

        const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
        const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";

        Promise.all([
          fetchImageAsBase64(logoUrl),
          fetchImageAsBase64(watermarkUrl)
        ]).then(([logoBase64, watermarkBase64]) => {

          createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {

            const documentSections = [];


            if (logoBase64) {
              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: logoBase64,
                                  transformation: {
                                    width: 80,
                                    height: 80
                                  }
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                            })
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 20, type: WidthType.PERCENTAGE },
                          margins: {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                          }
                        }),
                        new TableCell({
                          children: [
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "PIE POWER PRIVATE LIMITED",
                                  font: "Times New Roman",
                                  color: "#1e402c",
                                  bold: true,
                                  size: 36
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            }),
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                                  font: "helvetica",
                                  size: 20
                                })
                              ],
                              alignment: AlignmentType.CENTER
                            })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1 },
                            bottom: { style: BorderStyle.SINGLE, size: 1 },
                            left: { style: BorderStyle.SINGLE, size: 1 },
                            right: { style: BorderStyle.SINGLE, size: 1 }
                          },
                          width: { size: 80, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  ]
                })
              );
            } else {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "PIE POWER PRIVATE LIMITED",
                      font: "Times New Roman",
                      color: "#1e402c",
                      bold: true,
                      size: 36
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                      font: "Courier New",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                      font: "Courier New",
                      size: 20
                    })
                  ],
                  alignment: AlignmentType.CENTER
                })
              );
            }

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 20, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "CURRENT TRANSFORMER INSPECTION / TEST REPORT", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 50, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Date", font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ctFormData.date || "", font: "Courier New" })] })],
                        borders: tableBorders,
                        width: { size: 15, type: WidthType.PERCENTAGE }
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Project", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ctFormData.project || "", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Report No", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ctFormData.reportNo || "", font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Customer", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ctFormData.customer || "", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      })
                    ]
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Client", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ctFormData.client || "", font: "Courier New", bold: true })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "LOCATION: ",
                    font: "Courier New",
                    bold: true,
                    size: 24
                  }),
                  new TextRun({
                    text: ctFormData.location || '',
                    font: "Courier New",
                    size: 24
                  })
                ]
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            if (remainingFields.length > 0) {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "NAME PLATE DETAILS",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );

              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: remainingFields.map(field =>
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.label, font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 60, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.value, font: "Courier New" })] })],
                          borders: tableBorders,
                          width: { size: 40, type: WidthType.PERCENTAGE }
                        })
                      ]
                    })
                  )
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }


            if (coreDetails && coreDetails.length > 0) {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Core Details",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );

              const coreDetailsRows = [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Core", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 10, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Ratio", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Class", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    // new TableCell({
                    //   children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "VK", font: "Courier New", bold: true })] })],
                    //   borders: tableBorders,
                    //   shading: { fill: "a6a6a6" },
                    //   width: { size: 15, type: WidthType.PERCENTAGE }
                    // }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "VK Value", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Image@VK/2", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "RCT", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: { fill: "a6a6a6" },
                      width: { size: 15, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ];

              coreDetails.slice(0, numCores).forEach((core, index) => {
                coreDetailsRows.push(
                  new TableRow({
                    children: [
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `Core ${index + 1}`, font: "Courier New", bold: true })] })],
                        borders: tableBorders,
                        shading: { fill: "a6a6a6" }
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(core?.ratio || core?.Ratio || ''), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(core?.class || core?.Class || ''), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      // new TableCell({
                      //   children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(core?.vk || core?.VK || ''), font: "Courier New" })] })],
                      //   borders: tableBorders
                      // }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(core?.vkValue || core?.VKValue || core?.['VK Value'] || ''), font: "Courier New" })] })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({
                          alignment: AlignmentType.CENTER, children: [new TextRun({
                            text: safeToString(
                              core?.['Image@VK/2'] ||
                              core?.imageAtVkHalf ||
                              core?.ImageAtVkHalf ||
                              core?.['imageAtVK/2'] ||
                              core?.imageVkHalf ||
                              ''
                            ),
                            font: "Courier New"
                          })]
                        })],
                        borders: tableBorders
                      }),
                      new TableCell({
                        children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(core?.rct || core?.RCT || ''), font: "Courier New" })] })],
                        borders: tableBorders
                      })
                    ]
                  })
                );
              });

              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: coreDetailsRows
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }


            if (ctGeneralData?.generalInspection) {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "General Inspection",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );

              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Inspection Type", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 50, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Status", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" },
                          width: { size: 50, type: WidthType.PERCENTAGE }
                        })
                      ]
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Visual Inspection:", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(ctGeneralData?.generalInspection?.visualInspection), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Wiring Checking:", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(ctGeneralData?.generalInspection?.wiringChecking), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    }),
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Erection Checking:", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: { fill: "a6a6a6" }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(ctGeneralData?.generalInspection?.erectionChecking), font: "Courier New" })] })],
                          borders: tableBorders
                        })
                      ]
                    })
                  ]
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }



            if (ctGeneralData?.rows && ctGeneralData.rows.length > 0) {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Insulation Resistance Measurement",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );


              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 16.66, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 16.66, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 16.66, type: WidthType.PERCENTAGE }
                        })
                      ]
                    }),

                    ...Object.keys(ctGeneralData.formData || {}).map((reference, index) => {
                      const row = ctGeneralData.rows[index] || {};


                      const rowUnits = ctGeneralData.units && ctGeneralData.units[index]
                        ? ctGeneralData.units[index]
                        : { r: 'MÎ©', y: 'MÎ©', b: 'MÎ©' };
                      const rUnit = rowUnits.r || 'MÎ©';
                      const yUnit = rowUnits.y || 'MÎ©';
                      const bUnit = rowUnits.b || 'MÎ©';

                      return new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: reference, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(ctGeneralData.formData[reference]), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(row.r)} ${rUnit}`, font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(row.y)} ${yUnit}`, font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(row.b)} ${bUnit}`, font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      });
                    })
                  ]
                })
              );

              documentSections.push(new Paragraph({ text: "" }));
            }




            if (transformerWindingData?.windingResistance) {
              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Winding Resistance",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );


              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        })
                      ]
                    }),

                    ...Array.from({ length: numCores }, (_, i) => {
                      const ref = `${i + 1}S1-${i + 1}S2`;
                      const windingData = transformerWindingData.windingResistance?.[ref] || {};
                      const rData = windingData.R || {};
                      const yData = windingData.Y || {};
                      const bData = windingData.B || {};

                      return new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ref, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: rData.value ? `${rData.value} ${rData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: yData.value ? `${yData.value} ${yData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: bData.value ? `${bData.value} ${bData.unit || ''}` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      });
                    })
                  ]
                })
              );


              documentSections.push(new Paragraph({ text: "" }));


              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Polarity Check",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );


              documentSections.push(
                new Table({
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        }),
                        new TableCell({
                          children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                          borders: tableBorders,
                          shading: {
                            fill: "a6a6a6"
                          },
                          width: { size: 25, type: WidthType.PERCENTAGE }
                        })
                      ]
                    }),

                    ...Array.from({ length: numCores }, (_, i) => {
                      const ref = `${i + 1}S1-${i + 1}S2`;
                      const polarityData = transformerWindingData.polarityCheck?.[ref] || {};
                      const rData = polarityData.R || {};
                      const yData = polarityData.Y || {};
                      const bData = polarityData.B || {};

                      return new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: ref, font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(rData.value), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(yData.value), font: "Courier New" })] })],
                            borders: tableBorders
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(bData.value), font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      });
                    })
                  ]
                })
              );


              documentSections.push(new Paragraph({ text: "" }));


              documentSections.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Ratio Test",
                      font: "Courier New",
                      bold: true,
                      size: 24
                    })
                  ]
                })
              );


              Array.from({ length: numCores }, (_, i) => {
                const coreIndex = i + 1;
                const coreRatioData = ratioTestData?.[`ratioTest${coreIndex}`] || ratioTestData?.ratioTest;

                if (!coreRatioData) {
                  documentSections.push(
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `Core ${coreIndex} - No ratio test data available`,
                          font: "Courier New",
                          italic: true
                        })
                      ]
                    }),
                    new Paragraph({ text: "" })
                  );
                  return;
                }


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `Core ${coreIndex} (${coreIndex}S1-${coreIndex}S2)`,
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Applied Current (Primary)(A)",
                        font: "Courier New",
                        bold: true,
                        size: 20
                      })
                    ]
                  })
                );

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Percentage", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 25, type: WidthType.PERCENTAGE }
                          })
                        ]
                      }),

                      ...["25%", "50%", "75%", "100%"].map(percentage => {
                        const appliedData = coreRatioData.appliedCurrent?.[percentage] || {};
                        return new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: percentage, font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: {
                                fill: "a6a6a6"
                              }
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(appliedData.R), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(appliedData.Y), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(appliedData.B), font: "Courier New" })] })],
                              borders: tableBorders
                            })
                          ]
                        });
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));


                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Measured Current (Secondary)(A)",
                        font: "Courier New",
                        bold: true,
                        size: 20
                      })
                    ]
                  })
                );

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Percentage", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 14, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 14, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Error %", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 14, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 14, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Error %", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 14, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B-ph", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 15, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Error %", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 15, type: WidthType.PERCENTAGE }
                          })
                        ]
                      }),

                      ...["25%", "50%", "75%", "100%"].map(percentage => {
                        const measuredData = coreRatioData.measuredCurrent?.[percentage] || {};
                        return new TableRow({
                          children: [
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: percentage, font: "Courier New", bold: true })] })],
                              borders: tableBorders,
                              shading: {
                                fill: "a6a6a6"
                              }
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(measuredData.R), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: measuredData.RError ? `${measuredData.RError}` : "", font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(measuredData.Y), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: measuredData.YError ? `${measuredData.YError}` : "", font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(measuredData.B), font: "Courier New" })] })],
                              borders: tableBorders
                            }),
                            new TableCell({
                              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: measuredData.BError ? `${measuredData.BError}` : "", font: "Courier New" })] })],
                              borders: tableBorders
                            })
                          ]
                        });
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));
              });
            }



            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Knee Point Test Data",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ],
                alignment: AlignmentType.CENTER
              })
            );

            documentSections.push(new Paragraph({ text: "" }));


            if (typeof activeCores !== 'undefined' && typeof coreTestData !== 'undefined') {
              activeCores.forEach(coreIndex => {
                const coreData = coreTestData[coreIndex] || {};
                const coreNumber = parseInt(coreIndex) + 1;

                documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `Core ${coreNumber}`,
                        font: "Courier New",
                        bold: true,
                        size: 24
                      })
                    ]
                  })
                );


                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Field", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 50, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Value", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 50, type: WidthType.PERCENTAGE }
                          })
                        ]
                      }),
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Knee Voltage (Vk)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: coreData.kneeVoltage ? `${coreData.kneeVoltage} V` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      }),
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Half Knee Voltage (Vk/2)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: coreData.halfKneeVoltage ? `${coreData.halfKneeVoltage} V` : "", font: "Courier New" })] })],
                            borders: tableBorders
                          })
                        ]
                      })
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));


                const percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110];

                documentSections.push(
                  new Table({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    rows: [
                      new TableRow({
                        children: [
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Percentage (%)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 33, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage (V)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 34, type: WidthType.PERCENTAGE }
                          }),
                          new TableCell({
                            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Current (mA)", font: "Courier New", bold: true })] })],
                            borders: tableBorders,
                            shading: {
                              fill: "a6a6a6"
                            },
                            width: { size: 33, type: WidthType.PERCENTAGE }
                          })
                        ]
                      }),

                      ...((() => {
                        const hasAppliedVoltages = Object.values(coreData.appliedVoltage || {}).some(value => value !== "");
                        const hasMeasuredValues = Object.values(coreData.measuredCurrent || {}).some(value => value !== "");

                        if (hasAppliedVoltages || hasMeasuredValues) {
                          return percentages.map(percentage => {
                            const appliedV = coreData.appliedVoltage?.[percentage] || "";
                            const measuredC = coreData.measuredCurrent?.[percentage] || "";

                            return new TableRow({
                              children: [
                                new TableCell({
                                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${percentage}%`, font: "Courier New", bold: true })] })],
                                  borders: tableBorders,
                                  shading: {
                                    fill: "a6a6a6"
                                  }
                                }),
                                new TableCell({
                                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: appliedV ? `${appliedV} V` : "", font: "Courier New" })] })],
                                  borders: tableBorders
                                }),
                                new TableCell({
                                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: measuredC ? `${measuredC} mA` : "", font: "Courier New" })] })],
                                  borders: tableBorders
                                })
                              ]
                            });
                          });
                        } else {
                          return [
                            new TableRow({
                              children: [
                                new TableCell({
                                  children: [new Paragraph({ children: [new TextRun({ text: "No knee point measurements available", font: "Courier New", italic: true })] })],
                                  borders: tableBorders,
                                  columnSpan: 3
                                })
                              ]
                            })
                          ];
                        }
                      })())
                    ]
                  })
                );

                documentSections.push(new Paragraph({ text: "" }));
              });
            }

            documentSections.push(new Paragraph({ text: "" }));





            documentSections.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: "CT Check List",
                    font: "Courier New",
                    bold: true,
                    size: 28
                  })
                ]
              })
            );

            const storedChecklistData = JSON.parse(localStorage.getItem('points_checklist_data') || '{}');
            const currentChecklistData = storedChecklistData;

            const checklistRows = [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Sl. No.", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 10, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Check Point", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 70, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Remarks", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ];

            const checklistItemsForDoc = [
              { key: 'PNT-00', text: 'All CT quantity, rating, type & make are as per approved drawings.' },
              { key: 'PNT-01', text: 'No physical damage to any of the CT.' },
              { key: 'PNT-02', text: 'Inter-panel wiring from CTs to disconnector Terminal blocks in panel is as per approved drawing.' },
              { key: 'PNT-03', text: 'CT secondary star point terminals are properly earthed at disconnector terminal blocks.' },
              { key: 'PNT-04', text: 'CT wiring ferrules are as per drawing.' },
              { key: 'PNT-05', text: 'All CT connections are properly tightened.' }
            ];

            checklistItemsForDoc.forEach((item, index) => {
              checklistRows.push(
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: String(index + 1), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: item.text, font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: currentChecklistData[item.key] || "OK", font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              );
            });
            documentSections.push(
              new Table({
                width: { size: 100, type: WidthType.PERCENTAGE },
                rows: checklistRows
              })
            );
            documentSections.push(new Paragraph({ text: "" }));

            const convertInchesToTwip = (inches) => {
              return Math.round(inches * 1440);
            };


            const footerTable = new Table({
              width: { size: 100, type: WidthType.PERCENTAGE, },
              alignment: AlignmentType.LEFT,
              rows: [
                new TableRow({
                  height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "Pie Power",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          alignment: AlignmentType.LEFT,
                          spacing: { before: 0, after: 0 },
                          children: [
                            new TextRun({
                              text: "TPREL",
                              font: "Courier New",
                              bold: true,
                              size: 18
                            }),
                            new SimpleField({
                              instruction: "PAGE",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            }),
                            new SimpleField({
                              instruction: "NUMPAGES",
                              children: [
                                new TextRun({
                                  text: "1",
                                  font: "Courier New",
                                  size: 16
                                })
                              ]
                            })
                          ]
                        }),
                      ],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE },
                      verticalAlign: VerticalAlign.TOP,
                      margins: {
                        top: convertInchesToTwip(0.1),
                        bottom: convertInchesToTwip(0.25),
                        left: convertInchesToTwip(0.25),
                        right: convertInchesToTwip(0.25)
                      }
                    })
                  ]
                })
              ]
            });


            const pageBorders = {
              pageBorderTop: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderRight: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderBottom: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              },
              pageBorderLeft: {
                style: BorderStyle.DOUBLE,
                size: 6,
                color: "000000",
                space: 3
              }
            };

            const doc = new Document({

              sections: [
                {
                  properties: {
                    page: {
                      margin: {
                        top: convertInchesToTwip(0.5),
                        right: convertInchesToTwip(0.5),
                        bottom: convertInchesToTwip(1.0),
                        left: convertInchesToTwip(0.5)
                      },
                      borders: pageBorders,
                      pageNumbers: {
                        start: 1,
                        formatType: NumberFormat.DECIMAL
                      }
                    }
                  },
                  footers: {
                    default: new Footer({
                      children: [
                        footerTable,
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Page ",
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              children: [PageNumber.CURRENT],
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              text: " of ",
                              font: "Courier New",
                              size: 16
                            }),
                            new TextRun({
                              children: [PageNumber.TOTAL_PAGES],
                              font: "Courier New",
                              size: 16
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                          spacing: {
                            before: 200
                          }
                        })
                      ]
                    })
                  },
                  headers: lightWatermarkBase64 ? {
                    default: new Header({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: lightWatermarkBase64,
                              transformation: {
                                width: 500,
                                height: 500
                              },
                              floating: {
                                horizontalPosition: {
                                  relative: HorizontalPositionRelativeFrom.PAGE,
                                  align: HorizontalPositionAlign.CENTER
                                },
                                verticalPosition: {
                                  relative: VerticalPositionRelativeFrom.PAGE,
                                  align: VerticalPositionAlign.CENTER
                                },
                                wrap: {
                                  type: TextWrappingType.BEHIND_TEXT
                                },
                                allowOverlap: true,
                                behindDocument: true
                              }
                            })
                          ]
                        })
                      ]
                    })
                  } : undefined,
                  children: documentSections
                }
              ]
            });

            Packer.toBlob(doc).then(blob => {
              resolve(blob);
            }).catch(error => {
              console.error("Error generating Word blob:", error);
              reject(error);
            });
          }

          ).catch(error => {
            console.error("Error fetching logo:", error);
            reject(error);
          });

        })
      } catch (error) {
        console.error("Error generating Word blob:", error);
        reject(error);
      }
    });
  };
















  const handleCore1KneeVoltageChange = (e) => {
    const value = e.target.value;
    const currentCoreIndex = 0;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      newData[currentCoreIndex] = {
        ...newData[currentCoreIndex],
        kneeVoltage: value,
        halfKneeVoltage: value ? (parseFloat(value) / 2).toFixed(2) : ""
      };

      if (value) {
        const kneeVoltage = parseFloat(value);
        const appliedVoltage = {};

        percentages.forEach(percentage => {
          appliedVoltage[percentage] = ((kneeVoltage * percentage) / 100).toFixed(2);
        });

        newData[currentCoreIndex].appliedVoltage = appliedVoltage;
      } else {
        newData[currentCoreIndex].appliedVoltage = {};
      }

      return newData;
    });
  };

  const handleCore1CurrentChange = (e, percentage) => {
    const value = e.target.value;
    const currentCoreIndex = 0;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      if (!newData[currentCoreIndex].measuredCurrent) {
        newData[currentCoreIndex].measuredCurrent = {};
      }

      newData[currentCoreIndex].measuredCurrent[percentage] = value;

      return newData;
    });
  };

  const handleCore2KneeVoltageChange = (e) => {
    const value = e.target.value;
    const currentCoreIndex = 1;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      newData[currentCoreIndex] = {
        ...newData[currentCoreIndex],
        kneeVoltage: value,
        halfKneeVoltage: value ? (parseFloat(value) / 2).toFixed(2) : ""
      };

      if (value) {
        const kneeVoltage = parseFloat(value);
        const appliedVoltage = {};

        percentages.forEach(percentage => {
          appliedVoltage[percentage] = ((kneeVoltage * percentage) / 100).toFixed(2);
        });

        newData[currentCoreIndex].appliedVoltage = appliedVoltage;
      } else {
        newData[currentCoreIndex].appliedVoltage = {};
      }

      return newData;
    });
  };

  const handleCore2CurrentChange = (e, percentage) => {
    const value = e.target.value;
    const currentCoreIndex = 1;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      if (!newData[currentCoreIndex].measuredCurrent) {
        newData[currentCoreIndex].measuredCurrent = {};
      }

      newData[currentCoreIndex].measuredCurrent[percentage] = value;

      return newData;
    });
  };

  const handleCore3KneeVoltageChange = (e) => {
    const value = e.target.value;
    const currentCoreIndex = 2;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      newData[currentCoreIndex] = {
        ...newData[currentCoreIndex],
        kneeVoltage: value,
        halfKneeVoltage: value ? (parseFloat(value) / 2).toFixed(2) : ""
      };

      if (value) {
        const kneeVoltage = parseFloat(value);
        const appliedVoltage = {};

        percentages.forEach(percentage => {
          appliedVoltage[percentage] = ((kneeVoltage * percentage) / 100).toFixed(2);
        });

        newData[currentCoreIndex].appliedVoltage = appliedVoltage;
      } else {
        newData[currentCoreIndex].appliedVoltage = {};
      }

      return newData;
    });
  };

  const handleCore3CurrentChange = (e, percentage) => {
    const value = e.target.value;
    const currentCoreIndex = 2;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      if (!newData[currentCoreIndex].measuredCurrent) {
        newData[currentCoreIndex].measuredCurrent = {};
      }

      newData[currentCoreIndex].measuredCurrent[percentage] = value;

      return newData;
    });
  };

  const handleCore4KneeVoltageChange = (e) => {
    const value = e.target.value;
    const currentCoreIndex = 3;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      newData[currentCoreIndex] = {
        ...newData[currentCoreIndex],
        kneeVoltage: value,
        halfKneeVoltage: value ? (parseFloat(value) / 2).toFixed(2) : ""
      };

      if (value) {
        const kneeVoltage = parseFloat(value);
        const appliedVoltage = {};

        percentages.forEach(percentage => {
          appliedVoltage[percentage] = ((kneeVoltage * percentage) / 100).toFixed(2);
        });

        newData[currentCoreIndex].appliedVoltage = appliedVoltage;
      } else {
        newData[currentCoreIndex].appliedVoltage = {};
      }

      return newData;
    });
  };

  const handleCore4CurrentChange = (e, percentage) => {
    const value = e.target.value;
    const currentCoreIndex = 3;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      if (!newData[currentCoreIndex].measuredCurrent) {
        newData[currentCoreIndex].measuredCurrent = {};
      }

      newData[currentCoreIndex].measuredCurrent[percentage] = value;

      return newData;
    });
  };

  const handleCore5KneeVoltageChange = (e) => {
    const value = e.target.value;
    const currentCoreIndex = 4;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      newData[currentCoreIndex] = {
        ...newData[currentCoreIndex],
        kneeVoltage: value,
        halfKneeVoltage: value ? (parseFloat(value) / 2).toFixed(2) : ""
      };

      if (value) {
        const kneeVoltage = parseFloat(value);
        const appliedVoltage = {};

        percentages.forEach(percentage => {
          appliedVoltage[percentage] = ((kneeVoltage * percentage) / 100).toFixed(2);
        });

        newData[currentCoreIndex].appliedVoltage = appliedVoltage;
      } else {
        newData[currentCoreIndex].appliedVoltage = {};
      }

      return newData;
    });
  };

  const handleCore5CurrentChange = (e, percentage) => {
    const value = e.target.value;
    const currentCoreIndex = 4;

    setCoreTestData(prevData => {
      const newData = { ...prevData };

      if (!newData[currentCoreIndex]) {
        newData[currentCoreIndex] = {};
      }

      if (!newData[currentCoreIndex].measuredCurrent) {
        newData[currentCoreIndex].measuredCurrent = {};
      }

      newData[currentCoreIndex].measuredCurrent[percentage] = value;

      return newData;
    });
  };

  const getCoreData = (coreIndex) => {
    return coreTestData[coreIndex] || {
      kneeVoltage: "",
      halfKneeVoltage: "",
      appliedVoltage: {},
      measuredCurrent: {}
    };
  };




  return (
    <div className="pnt-00">

      <div className="pnt-01" id="knee-point-content">
        <span
          className="pnt-02"
          onClick={redirectToHome}
        >
          X
        </span>
        <div className="test-header">
          <h2 className="head">Knee Point Test</h2>

          <div className="core-count-container">
            <label htmlFor="coreCount">Number of Cores:</label>
            <select
              id="coreCount"
              value={selectedCoreCount}
              onChange={handleCoreCountChange}
              className="core-count-select"
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
        </div>

        {errorMessage && (
          <div className="pnt-03">
            {errorMessage}
          </div>
        )}

        <div className="core-tabs">
          {activeCores.map((coreIndex, index) => (
            <button
              key={coreIndex}
              className={`core-tab ${activeTab === index ? 'active-tab' : ''}`}
              onClick={() => handleTabChange(index)}
            >
              Core {coreIndex + 1}
            </button>
          ))}
        </div>

        <div className="core-content">
          {activeCores.map((coreIndex, index) => {
            const currentData = coreTestData[coreIndex] || {};

            let kneeVoltageHandler, currentHandler;

            switch (coreIndex) {
              case 0:
                kneeVoltageHandler = handleCore1KneeVoltageChange;
                currentHandler = handleCore1CurrentChange;
                break;
              case 1:
                kneeVoltageHandler = handleCore2KneeVoltageChange;
                currentHandler = handleCore2CurrentChange;
                break;
              case 2:
                kneeVoltageHandler = handleCore3KneeVoltageChange;
                currentHandler = handleCore3CurrentChange;
                break;
              case 3:
                kneeVoltageHandler = handleCore4KneeVoltageChange;
                currentHandler = handleCore4CurrentChange;
                break;
              case 4:
                kneeVoltageHandler = handleCore5KneeVoltageChange;
                currentHandler = handleCore5CurrentChange;
                break;
              default:
                kneeVoltageHandler = handleCore1KneeVoltageChange;
                currentHandler = handleCore1CurrentChange;
            }

            return (
              <div key={coreIndex} className={`core-panel ${activeTab === index ? 'active-panel' : 'hidden-panel'}`}>
                <h3>Core {coreIndex + 1} Test Data</h3>

                <div className="voltage-inputs-row">
                  <div className="voltage-input-container">
                    <label>Knee Voltage (Vk):</label>
                    <input
                      type="number"
                      value={currentData.kneeVoltage || ""}
                      onChange={kneeVoltageHandler}
                      placeholder="Enter knee voltage"
                      className="voltage-input"
                    />
                  </div>

                  <div className="voltage-input-container">
                    <label>Vk/2:</label>
                    <input
                      type="text"
                      value={currentData.halfKneeVoltage || ""}
                      readOnly
                      placeholder="Half knee voltage"
                      className="voltage-input"
                    />
                  </div>
                </div>

                <div className="pnt-04">
                  <table className="test-table">
                    <thead>
                      <tr>
                        <th>Percentage (%)</th>
                        <th>Applied Voltage (V)</th>
                        <th>Measured Current (mA)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {percentages.map((percentage) => {
                        return (
                          <tr key={percentage}>
                            <td>{percentage}%</td>
                            <td>
                              <input
                                type="text"
                                readOnly
                                value={(currentData.appliedVoltage || {})[percentage] || ""}
                                placeholder="Enter Vk first"
                                className="table-input"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                placeholder="Enter Measured Current"
                                value={(currentData.measuredCurrent || {})[percentage] || ""}
                                onChange={(e) => currentHandler(e, percentage)}
                                className="table-input"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>


      </div>



      <div className="pnt-06">
        <h2 className="pnt-07">CT Check List</h2>

        <div className="pnt-08">
          <table className="pnt-09">
            <thead>
              <tr>
                <th className="pnt-10">Sl. No.</th>
                <th className="pnt-11">Check Point</th>
                <th className="pnt-12">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {checklistItems.map((item, index) => (
                <tr key={item.key}>
                  <td className="pnt-13">{index + 1}</td>
                  <td className="pnt-14">{item.text}</td>
                  <td className="pnt-15">
                    <select
                      className="pnt-16"
                      value={checklistData[item.key] || ''}
                      onChange={(e) => handleChecklistChange(item.key, e.target.value)}
                      disabled={isLoading}
                    >
                      <option value="">Select</option>
                      <option value="OK">OK</option>
                      <option value="Not OK">Not OK</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>



      <div className="pnt-05">
        <button className="cancel-btn" onClick={goBack} disabled={isLoading}>Back</button>
        <button className="save-btn" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? "Processing..." : "Submit"}
        </button>

        {formSubmitted && (
          <button
            type="button"
            className="download-btn"
            onClick={handleDownloadPDF}
            disabled={isLoading}
          >
            Download Word
          </button>
        )}
      </div>

    </div>
  );


};

export default KneePointTest;

























